export class OrderData {
    orderid = ""; 
    PONumber = ""; 
    ordernumber = ""; 
    description = ""; 
    createdby = ""; 
    createdon = ""; 
    submitdate = ""; 
    d365pros_orderfulfilled = false;
    datefulfilled = ""; 
    d365pros_orderfulfilledname = ""; 
    d365pros_relatedagreementname = ""; 
    modifiedby = ""; 
    modifiedon = ""; 
    state = ""; 
    products: OrderProduct[] = new Array<OrderProduct>();
}

export class OrderProduct {
    productmapname = "";
    count = 0;
}